import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class IOSContextMenuBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.eventDispatched = false;
        this.onTouchEnd = (event) => {
            var _a;
            const isTextSelected = !!((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString());
            if (isTextSelected && !this.eventDispatched) {
                this.eventDispatched = true;
                if (this.addMetadata != null) {
                    const eventMeta = this.addMetadata(event);
                    const { questionId } = eventMeta;
                    if (questionId != null) {
                        setTimeout(() => {
                            this.captureScreenshot({ trigger: "question-selection-context-menu-called" });
                        }, 200);
                    }
                }
                this.addLog(event, this.id);
                setTimeout(() => {
                    this.eventDispatched = false;
                }, 200);
            }
        };
        this.id = BehaviorType.contextmenu;
        this.handler = () => { };
        this.iframeBehaviorListeners = [{ type: "touchend", listener: this.onTouchEnd }];
    }
    start() {
        window.addEventListener("touchend", this.onTouchEnd);
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        window.removeEventListener("touchend", this.onTouchEnd);
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
}
export default IOSContextMenuBehavior;
